import { BaseRequestType } from 'types/RequestHandler';
import { IUploadFileResponse } from 'types/signNow/store';
import axiosInstance from 'utils/axiosInstance';

export const uploadFile: BaseRequestType<IUploadFileResponse, FormData> = (formData) => (
  axiosInstance.post('/pdf-template/files', formData)
);

export default undefined;